import { API_ENDPOINTS } from "../../config/api.js";
import { makeApiRequest } from "../apiClient.js";

const token = () => localStorage.getItem("accessToken");

const normalizeFeatureColumns = (featureColumns = []) =>
  (Array.isArray(featureColumns) ? featureColumns : [])
    .map((item) => String(item || "").trim())
    .filter(Boolean);

const buildQuery = (params = {}) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((entry) => {
        if (entry !== undefined && entry !== null && String(entry).trim() !== "") {
          searchParams.append(key, String(entry));
        }
      });
      return;
    }
    if (value === undefined || value === null || String(value).trim() === "") return;
    searchParams.append(key, String(value));
  });
  return searchParams.toString();
};

export const mlService = {
  uploadDataSet: async (companyId, file) => {
    try {
      const formData = new FormData();
      formData.append("CompanyId", Number(companyId || 0));
      formData.append("File", file);
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.ML_UPLOAD_DATASET,
        method: "POST",
        data: formData,
        contentType: "form",
        accessToken: token(),
      });
      return response.data;
    } catch (error) {
      console.error("Upload dataset error:", error);
      throw error;
    }
  },

  getAllDataSetsByCompanyId: async (companyId) => {
    try {
      const query = buildQuery({ CompanyId: Number(companyId || 0) });
      const response = await makeApiRequest({
        endpoint: `${API_ENDPOINTS.ML_GET_ALL_DATASETS_BY_COMPANY_ID}?${query}`,
        method: "GET",
        accessToken: token(),
      });
      return response.data;
    } catch (error) {
      console.error("Get datasets by company error:", error);
      throw error;
    }
  },

  deleteDataSetById: async (sourceId, deletedBy) => {
    try {
      const query = buildQuery({
        SourceId: Number(sourceId || 0),
        DeletedBy: Number(deletedBy || 0),
      });
      const response = await makeApiRequest({
        endpoint: `${API_ENDPOINTS.ML_DELETE_DATASET_BY_ID}?${query}`,
        method: "POST",
        accessToken: token(),
      });
      return response.data;
    } catch (error) {
      console.error("Delete dataset error:", error);
      throw error;
    }
  },

  saveMLModel: async ({
    createdBy,
    sourceId,
    companyId,
    mlModelName,
    timeColumn,
    featureColumns,
    targetColumn,
    description,
    preferredModel,
  }) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.ML_SAVE_MODEL,
        method: "POST",
        data: {
          CreatedBy: Number(createdBy || 0),
          SourceId: Number(sourceId || 0),
          CompanyId: Number(companyId || 0),
          MLModelName: mlModelName || "",
          TimeColumn: timeColumn || "",
          FeatureColumns: normalizeFeatureColumns(featureColumns),
          TargetColumn: targetColumn || "",
          Description: description || "",
          PreferredModel: preferredModel || "",
        },
        accessToken: token(),
      });
      return response.data;
    } catch (error) {
      console.error("Save ML model error:", error);
      throw error;
    }
  },

  buildMLModel: async (companyId, mlModelId) => {
    try {
      const query = buildQuery({
        CompanyId: Number(companyId || 0),
        MLModelId: Number(mlModelId || 0),
      });
      const response = await makeApiRequest({
        endpoint: `${API_ENDPOINTS.ML_BUILD_MODEL}?${query}`,
        method: "POST",
        accessToken: token(),
      });
      return response.data;
    } catch (error) {
      console.error("Build ML model error:", error);
      throw error;
    }
  },

  getAllMLModelTypes: async () => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.ML_GET_ALL_MODEL_TYPES,
        method: "GET",
        accessToken: token(),
      });
      return response.data;
    } catch (error) {
      console.error("Get ML model types error:", error);
      throw error;
    }
  },

  getAllMLModelsByCompanyId: async (companyId) => {
    try {
      const normalizedCompanyId = Number(companyId || 0);
      const query = buildQuery({
        CompanyId: normalizedCompanyId,
        companyId: normalizedCompanyId,
      });
      const response = await makeApiRequest({
        endpoint: `${API_ENDPOINTS.ML_GET_ALL_MODELS_BY_COMPANY_ID}?${query}`,
        method: "GET",
        accessToken: token(),
      });
      return response.data;
    } catch (error) {
      console.error("Get ML models by company error:", error);
      throw error;
    }
  },

  deleteMLModelById: async (companyId, mlModelId, deletedBy) => {
    try {
      const query = buildQuery({
        CompanyId: Number(companyId || 0),
        MLModelId: Number(mlModelId || 0),
        DeletedBy: Number(deletedBy || 0),
      });
      const response = await makeApiRequest({
        endpoint: `${API_ENDPOINTS.ML_DELETE_MODEL_BY_ID}?${query}`,
        method: "DELETE",
        accessToken: token(),
      });
      return response.data;
    } catch (error) {
      console.error("Delete ML model error:", error);
      throw error;
    }
  },

  testMLModel: async (companyId, modelName, inputs = []) => {
    try {
      const query = buildQuery({
        CompanyId: Number(companyId || 0),
        ModelName: modelName || "",
        Inputs: Array.isArray(inputs) ? inputs : [],
      });
      const response = await makeApiRequest({
        endpoint: `${API_ENDPOINTS.ML_TEST_MODEL}?${query}`,
        method: "GET",
        accessToken: token(),
      });
      return response.data;
    } catch (error) {
      console.error("Test ML model error:", error);
      throw error;
    }
  },
};
